import { render, staticRenderFns } from "./ShareIcons.vue?vue&type=template&id=47f32460&scoped=true&"
import script from "./ShareIcons.vue?vue&type=script&lang=js&"
export * from "./ShareIcons.vue?vue&type=script&lang=js&"
import style0 from "./ShareIcons.vue?vue&type=style&index=0&id=47f32460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f32460",
  null
  
)

export default component.exports